import { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import InstitutionService from "../../../services/InstitutionService";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
    md: {
      span: 9,
    },
    lg: {
      span: 10,
    },
    xl: {
      span: 10,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
    md: {
      span: 15,
    },
    lg: {
      span: 14,
    },
    xl: {
      span: 14,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
export default function InstitutionModalForm({
  isModalVisible,
  handleOk,
  handleCancel,
  institutionTarget = null,
}) {
  const [form] = Form.useForm();
  const [formField, setformField] = useState(null);
  useEffect(() => {
    if (institutionTarget) {
      setformField([
        { name: ["name"], value: institutionTarget.name },
        { name: ["shortName"], value: institutionTarget.shortName },
        { name: ["country"], value: institutionTarget.country },
      ]);
    }
  }, [institutionTarget]);
  const onFinish = (values) => {
    let institutionR = { ...values };
    //console.log("values", values);
    if (institutionTarget) {
        institutionR.id = institutionTarget.id;
      InstitutionService.updateInstitution(institutionR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Institución actualizada.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo actualizar la Institución. " + res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message, 5);
        });
    } else {
        InstitutionService.createInstitution(institutionR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Institución registrada.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo registar la Institución. " + res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message);
        });
    }
  };
  return (
    <Modal
      title="Registrar Carrera"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      footer={null}
    >
      <Form
        className="form"
        {...formItemLayout}
        form={form}
        fields={formField}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          name="name"
          label="Nombre de la Carrera"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el nombre de la carrera.",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="shortName"
          label="Siglas"
          rules={[
            {
              required: true,
              message: "Por favor ingresa las siglas de la carrera",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="country"
          label="Pais"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el nombre del Pais de la institución",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Aceptar
          </Button>
          <Button
            type="secondary"
            htmlType="button"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
